import MpBaseWidget from '../../MpBaseWidget.js';

/**
 * @typedef {import('./types').LazyApi} LazyApi
 */

export default class MpCodeEditor extends MpBaseWidget {

	/** @type {string} */
	static NAME = 'MpCodeEditor';

	/**
	 * @type {DynamicWidgetConfig}
	 */
	static config = {
		name: 'code-editor', // must match the parent folder name
		optionsDataName: 'codeEditor', // js data name
		selector: 'textarea[data-code-editor]', // css selector
		sideEffects: false,
		allowReInit: true,
	};

	/**
	 * @protected
	 *
	 * @param {JQuery} $element
	 */
	static addCustomHandlersBefore($element) {

		$element.on(`disable.bind-change-action.${this.getEventNs()}`, async (e, { disabled }) => {

			/** @type {LazyApi} */
			const lazyApi = await this.getInstanceRef($element);

			$element.prop('disabled', disabled);

			// Disable the editor
			if (disabled) {
				if (lazyApi.editor) {
					lazyApi.editor.updateOptions({ readOnly: true });
				}
				else {
					lazyApi.onReady = () => {
						lazyApi.editor.updateOptions({ readOnly: true });
					};
				}
			}
			// Enable the editor
			else {
				if (lazyApi.editor) {
					lazyApi.editor.updateOptions({ readOnly: false });
				}
				else {
					lazyApi.onReady = () => {
						lazyApi.editor.updateOptions({ readOnly: false });
					};
				}
			}
		});
	}
}